import { ProviderCalendarId } from "@/entities/providerCalendar"

export function getAnnualConsumption(
    annualConsumption: {
        allDay: number | null
        peak: number | null
        offPeak: number | null
    } | null,
    providerCalendarId?: string | null
): { allDay: number } | { peak: number; offPeak: number } | null {
    if (!annualConsumption) return null

    if (
        annualConsumption.allDay !== null &&
        (providerCalendarId === ProviderCalendarId.BASE || !providerCalendarId)
    ) {
        return { allDay: annualConsumption.allDay }
    }

    if (
        annualConsumption.peak !== null &&
        annualConsumption.offPeak !== null &&
        (providerCalendarId === ProviderCalendarId.HPHC || !providerCalendarId)
    ) {
        return { peak: annualConsumption.peak, offPeak: annualConsumption.offPeak }
    }

    return null
}
